import { FieldKey, OptionKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { CheckboxFormField, FormFields } from '@core/data-access/models/form/form-store.model';
import { FormName } from '@core/data-access/models/form/form.model';
import { TicketSendingOption } from '@core/data-access/models/shared/ticket-sending-options.model';
import {
  TicketAssignmentStoreState,
  TicketHolderForms
} from '@core/features/ticket-assignment/models/ticket-assignment-store.model';
import { SendingOptionModel } from '@products/models/product-selection.model';
import { TariffUuid } from '@products/models/tariff.model';
import { find, merge, reduce } from 'lodash';

export const setSendToOwnerFormField = (
  state: TicketAssignmentStoreState,
  tariffUuid: TariffUuid,
  formFields: FormFields
) => {
  const { forms } = state;

  return {
    ...state,
    forms: {
      ...forms,
      [FormName.TicketHolder]: {
        ...forms[FormName.TicketHolder],
        [tariffUuid]: {
          ...forms[FormName.TicketHolder][tariffUuid],
          formFields: {
            ...forms[FormName.TicketHolder][tariffUuid].formFields,
            ...formFields
          }
        }
      }
    }
  };
};

export const setTicketHolderSendingOptionFormFields = (
  state: TicketAssignmentStoreState,
  tariffUuid: TariffUuid,
  formFields: FormFields
) => {
  const { forms } = state;

  return {
    ...state,
    forms: {
      ...forms,
      [FormName.TicketHolder]: {
        ...forms[FormName.TicketHolder],
        [tariffUuid]: {
          ...forms[FormName.TicketHolder][tariffUuid],
          formFields: {
            ...forms[FormName.TicketHolder][tariffUuid].formFields,
            ...formFields
          }
        }
      }
    }
  };
};

export const setTicketHolderSendToOwnerFormFields = (
  state: TicketAssignmentStoreState,
  sendingOptions: SendingOptionModel[]
) => {
  const { forms } = state;

  const selectedTicketSendingOption = find(sendingOptions, ({ isSelected }) => isSelected)?.value;

  const updatedTicketHolderFormsSendToOwnerField = reduce(
    forms[FormName.TicketHolder],
    (updatedTicketHolderFormsSendToOwnerField, { formFields, person }, tariffUuid) => {
      const sendToOwnerFormField = {
        [FieldKey.SendToOwner]: {
          value: {
            [OptionKey.ToOwner]: {
              value: selectedTicketSendingOption === TicketSendingOption.NormalPerOwner,
              isQuestionnaire: false
            }
          },
          isQuestionnaire: false
        } as CheckboxFormField
      };

      updatedTicketHolderFormsSendToOwnerField[tariffUuid] = {
        person,
        formFields: merge({}, formFields, sendToOwnerFormField)
      };

      return updatedTicketHolderFormsSendToOwnerField;
    },
    {} as TicketHolderForms
  );

  return {
    ...state,
    forms: {
      ...forms,
      [FormName.TicketHolder]: updatedTicketHolderFormsSendToOwnerField
    }
  };
};
